import React from 'react';
import { IconButton } from 'src/components/atomsLegacy/buttons';
import { NavbarVariantEnum } from 'src/types';
import styled from 'styled-components';

export const FullWidthContainer = styled.div<{ isHidden?: boolean }>`
  width: 100%;

  @media screen and (min-width: 0px) and (max-width: 480px) {
    ${(props) => props.isHidden && 'display: none;'}
  }
`;

export const Header = styled.div`
  background: none;
  width: 100%;
  display: flex;
  align-items: center;
  margin: 0;

  @media screen and (min-width: 0px) and (max-width: 480px) {
    border-bottom: none;
    background: none;
  }
`;

export const HeaderTitle = styled.h1<{ children?: React.ReactNode }>`
  ${(props) => props.theme.newTypography.textStyleDisplayLarge}
  margin-top: 20px;
  @media screen and (min-width: 0px) and (max-width: 480px) {
    color: ${(props) => props.theme.newPalette.neutral.N800};
    ${(props) => props.theme.newTypography.textStyleBodyLargeSemibold}
  }
`;

export const HeaderLogo = styled.img`
  max-height: 30px;
  min-height: 70px;

  @media screen and (min-width: 0px) and (max-width: 480px) {
    min-height: 44px;
  }
`;

export const SubHeader = styled.h4<{ children?: React.ReactNode }>`
  margin: 0 0 10px 0;
  width: 100%;
  ${(props) => props.theme.newTypography.textStyleBodySemibold}
  text-align: center;
`;

export const HeaderContainer = styled.div<{
  variant?: NavbarVariantEnum;
}>`
  display: flex;
  align-items: center;
  justify-content: center;
  width: 100%;
  flex-direction: column;
  margin-bottom: 20px;
  margin-top: 40px;

  @media screen and (min-width: 0px) and (max-width: 480px) {
    margin-top: ${(props) =>
      props.variant === NavbarVariantEnum.PUBLIC ? '60px' : '40px'};
  }
`;

export const StyledIconButton = styled(IconButton)`
  margin-left: -40px;
`;
